import { CamerasState } from "./types";

export const initialState: CamerasState = {
  currentCameras: [],
  currentStreams: {},
  streamStatuses: {},
  browseFrames: {},
  ptzCapibilities: {},
  ptzModes: {},
  presets: {},
  openedCameraList: false,
  cameraListSearchQuery: ''
};